import { iFixitHotSpotItem } from './iFixitHotSpotItem';
import { HotSpot as HotSpotType } from 'Guide/Schematics/Diagram/Providers/dataContext';
import { TooltipContext } from '../Providers/tooltipContext';
import { KeyboardEventHandler, useCallback, useContext } from 'react';
import HotspotTooltip from '../UI/hotspotTooltip';
import { withOrderContext } from '../Providers/orderContext';
import { BasicHotspot } from 'Guide/Schematics/Diagram/Generic/basicHotspot';
import { useDiagramTheme } from '../Providers/themes';

export const HotSpot = withOrderContext(function HotSpotInternal({
   hotspot,
}: {
   hotspot: HotSpotType<iFixitHotSpotItem>;
}) {
   const tooltipContext = useContext(TooltipContext);
   const diagramTheme = useDiagramTheme();
   const hotspotInner = diagramTheme.hotspotInner;
   const hotspotOuter = diagramTheme.hotspotOuter;
   const showTooltip = tooltipContext.openDataPointId == hotspot.id;

   const togglePoint = useCallback(() => {
      const isOpen = tooltipContext.openDataPointId == hotspot.id;
      if (isOpen) {
         tooltipContext.setOpenDataPointId(null);
      } else {
         tooltipContext.setOpenDataPointId(hotspot.id);
      }
   }, [tooltipContext.openDataPointId, hotspot.id]);

   const onKeyDown = useCallback<KeyboardEventHandler<SVGGElement>>(
      event => {
         if (event.key === 'Enter') {
            togglePoint();
         }
      },
      [togglePoint]
   );

   return (
      <HotspotTooltip data={hotspot} visible={showTooltip}>
         <BasicHotspot
            groupProps={{
               tabIndex: hotspot.tabIndex,
               onKeyDown: onKeyDown,
               onClick: togglePoint,
               focusable: 'true',
               role: 'group',
            }}
            innerCircleProps={{
               fill: hotspotInner,
               hoverFill: hotspotOuter,
               focusFill: hotspotOuter,
            }}
            outerCircleProps={{
               fill: hotspotOuter,
               hoverFill: hotspotInner,
               focusFill: hotspotInner,
            }}
            x={hotspot.scaledX ?? 0}
            y={hotspot.scaledY ?? 0}
         />
      </HotspotTooltip>
   );
});
